import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { __ } from '../../../i18n/l10n';
import { WS_GET_PAYPAL_LOGIN_URL_REQUEST } from '../../../store/actions';
import { Button } from '../../shared';

const PaypalButton = styled(Button)`
  background-color: #0070ba;
  border-color: #0070ba;
  color: #ffffff;
  line-height: 18px;
  width: auto;
  margin: 20px 0;
  border-radius: 50px;
  text-transform: unset;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 30px;
  padding: 6px 18px;

  .inner .pictoWrapper {
    margin-right: 9px;
    width: 18px;
    height: 18px;
  }
  &:hover {
    background-color: #0070ba;
    color: #eeeeee;
  }
  &:focus {
    border-color: #0070ba;
  }
`;

export function PaypalConnectButton() {
  const dispatch = useDispatch();
  const paypalConnect = useSelector(state => state.paypalConnect);

  useEffect(() => {
    if (paypalConnect.url) {
      window.location.href = paypalConnect.url;
    }
  }, [paypalConnect.url]);

  const handleClick = (e) => {
    dispatch({ type: WS_GET_PAYPAL_LOGIN_URL_REQUEST });
  };

  return (
    <PaypalButton
      type={'button'}
      picto={'paypal'}
      pictoLocation={'left'}
      onClick={handleClick}
      isDisabled={!!paypalConnect.isFetchingUrl}
    >
      {__('Continue with PayPal')}
    </PaypalButton>
  );
}
